import { action } from 'satcheljs';

export const onLoadingChanged = action('onLoadingChanged', (isLoading: boolean) => ({ isLoading }));
export const onFeatureFlagChanged = action('onFeatureFlagChanged', (isFeatureEnabled: boolean) => ({ isFeatureEnabled }));
